import React from "react";

import PrivacyPolicyPage from "@/pages/Privacy/PrivacyPage";

export default function Layout(): React.JSX.Element {
  return <PrivacyPolicyPage />;
}
